module.exports = __webpack_public_path__ + "static/banner-73f45c0e956634ae9bf30b30c6a74998.png";